/* ============================================================
   Announcement bar — mobile auto-rotation.

   - Active only when (max-width: 768px) matches.
   - Cycles through .zc-announcement__msg elements toggling the
     `is-active` class. CSS handles the crossfade.
   - 4s between switches.
   - Pauses on hover (irrelevant on touch, but useful for testing
     and for hybrid devices) and on focus-within (keyboard a11y).
   - prefers-reduced-motion: reduce → fade becomes instant via
     foundations.css global rule; the rotation itself still runs
     so users with reduced motion still see all messages.
   ============================================================ */
(function () {
  'use strict';

  const INTERVAL_MS = 4000;
  const MOBILE_MQ = window.matchMedia('(max-width: 768px)');

  const bar = document.querySelector('[data-zc-announcement]');
  if (!bar) return;

  const messages = Array.from(bar.querySelectorAll('[data-zc-announcement-msg]'));
  if (messages.length <= 1) return;

  let activeIndex = 0;
  let intervalId = null;
  let isPaused = false;

  const setActive = (idx) => {
    activeIndex = ((idx % messages.length) + messages.length) % messages.length;
    messages.forEach((m, i) => {
      m.classList.toggle('is-active', i === activeIndex);
    });
  };

  const tick = () => {
    if (isPaused) return;
    setActive(activeIndex + 1);
  };

  const start = () => {
    stop();
    intervalId = setInterval(tick, INTERVAL_MS);
  };

  const stop = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  const applyMqState = () => {
    if (MOBILE_MQ.matches) {
      // Mobile: ensure exactly one message is active, then start.
      setActive(0);
      start();
    } else {
      // Desktop: stop the rotation and let CSS show all messages
      // inline. The `is-active` class on the first message is
      // harmless (opacity rules don't apply outside the mobile MQ).
      stop();
    }
  };

  applyMqState();

  if (typeof MOBILE_MQ.addEventListener === 'function') {
    MOBILE_MQ.addEventListener('change', applyMqState);
  } else if (typeof MOBILE_MQ.addListener === 'function') {
    MOBILE_MQ.addListener(applyMqState);
  }

  // Pause on hover (mouse) and focus (keyboard).
  bar.addEventListener('mouseenter', () => { isPaused = true; });
  bar.addEventListener('mouseleave', () => { isPaused = false; });
  bar.addEventListener('focusin', () => { isPaused = true; });
  bar.addEventListener('focusout', () => { isPaused = false; });

  // Pause when the tab is hidden to save battery / cycles.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stop();
    } else if (MOBILE_MQ.matches) {
      start();
    }
  });
})();
